import {useEffect, useMemo, useState} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import EditorButton from "../../../../../../components/reports/editor-report/editor-button.jsx";
import EditorInput from "../../../../../../components/reports/editor-report/editor-input.jsx";

export default function OccurrenceNeighborhood({ data, setMode }) {
    const [callEditor, setCallEditor] = useState(false);

    const occurrenceNeighborhoodChart = useMemo(() => {
        const source = data?.occurrencesNeighborhood || [];

        return {
            labels: source.map(item => item.neighborhood),
            values: source.map(item => Number(item.qty || 0)),
        };
    }, [data]);

    useEffect(() => {
        GraphicUtils.barChart(
            "occurence-neighborhood-chart",
            occurrenceNeighborhoodChart.values,
            occurrenceNeighborhoodChart.labels,
            true,
        );
    }, [occurrenceNeighborhoodChart]);

    return (
        <>
            <div className="chart-report">
                <div className="flex flex-row gap-2">
                    <span className="chart-title">Ocorrências por bairro</span>
                    <EditorButton callEditor={callEditor} setCallEditor={setCallEditor}/>
                </div>

                <div className="mt-3" id="occurence-neighborhood-chart"/>
            </div>

            <EditorInput callEditor={callEditor} setMode={setMode}/>
            <div className="chart-divisor print:hidden! d-none"/>
        </>
    )
}